<section class="content-container p-l-0 p-tb-0 p-r-20 full-grow-no-shrink-no-basis">
  <div *ngIf="item.editor && item.editor.length" class="each-section flex flex-col">
    <header>

    </header>
    <div class="w-p-100">
      <ng-container #dynamicComponent></ng-container>
    </div>
  </div>
  <div *ngIf="!(item.editor && item.editor.length)" class="each-section flex flex-col">
    <header>

    </header>
  </div>
</section>


<!--<aside fxFlex="0 0 280px" class="p-l-20 p-tb-0 p-r-0" fxLayout="column" fxLayoutAlign="start start">
  <div class="wrapper w-p-100" fxLayout="column" fxLayoutAlign="start start">
    <div class="list-container w-p-100">

      <div class="list">
        <header fxFLayout="row" fxLayoutAlign="start center">
          <i class="fal fa-info-circle"></i>
          <div>Details</div>
        </header>
        <div class="content">
          {{item.details}}
        </div>
      </div>
&lt;!&ndash;      <div class="list">
        <header fxFLayout="row" fxLayoutAlign="start center">
          <i class="far fa-comment-alt-lines"></i>
          <div>Example</div>
        </header>
        <div class="content">
          {{item.example}}
        </div>
      </div>&ndash;&gt;
    </div>
  </div>
</aside>-->
